// Admin callers opt in; common_font and the customer font faces stay unchanged.
const family = 'font-family: var(--font-family-base);';
export const fontStyles = {
  regular: `${family} font-weight: var(--font-weight-regular);`,
  medium: `${family} font-weight: var(--font-weight-medium);`,
  semiBold: `${family} font-weight: var(--font-weight-semibold);`,
  Bold: `${family} font-weight: var(--font-weight-bold);`,
};
